<template>
  <InputGroup>
    <!-- <AutoComplete
      v-model="data"
      multiple
      :suggestions="DataItem"
      optionLabel="name"
      @complete="SearchItemData"
      @change="FunChangeItem"
      class="w-full"
      placeholder="Chọn hàng/nhóm"
    /> -->
    <MultiSelect v-model="data" display="chip" :options="data"   optionLabel="name"  
       placeholder="Chọn hàng/nhóm"
    />
    <InputGroupAddon @click="ChooseGroupItem">
      <i class="pi pi-list"></i>
    </InputGroupAddon>
  </InputGroup>
  <Dialog
    v-model:visible="dialogGroupItem"
    modal
    header="Chọn nhóm hàng"
    :style="{ width: '500px' }"
  >
    <div class="p-2">
      <!-- <div class="mb-3">
        <InputGroup>
          <InputGroupAddon>
            <i class="pi pi-search"></i>
          </InputGroupAddon>
          <InputText placeholder="Tìm kiếm nhóm hàng hoá" @keyup="keyUpSreachGItem()" />
        </InputGroup>
      </div> -->
      <Tree
        v-model:selectionKeys="dataNode"
        :value="dataGroupItem"
        selectionMode="single"
        class="w-full p-0 m-0"
      >
      </Tree>
    </div>
    <template #footer>
      <div class="flex justify-content-end w-full">
        <div class="flex gap-3">
          <Button
            label="Bỏ qua"
            icon="pi pi-ban"
            severity="secondary"
            @click="dialogGroupItem = false"
          />
          <Button label="Xong" icon="pi pi-check-circle" @click="saveData()" />
        </div>
      </div>
    </template>
  </Dialog>
</template>
<script setup>
import { ref, watchEffect, onBeforeMount } from "vue";
import { getCurrentInstance } from "vue";
import API from "../../../api/api-main";
import { useToast } from "primevue/usetoast";
import { debounce } from "lodash";

onBeforeMount(() => {
  emit("handle", false);
});
const props = defineProps({
  data_req: Object,
});
const emit = defineEmits(["change", "handle"]);
const { proxy } = getCurrentInstance();
const toast = useToast();
const dialogGroupItem = ref(false);
const dataGroupItem = ref([]);
const DataItem = ref([]);
const data = ref([]);
const dataNode = ref([]);
const ChooseGroupItem = async () => {
  try {
    const res = await API.get("ItemGroup/GetItemGroup");
    if (res.data.itemGroups) dataGroupItem.value = res.data.itemGroups;    
    ConvertData(dataGroupItem.value);
  } catch (error) {
    proxy.$notify("E", error, toast);
  } finally {
    dialogGroupItem.value = true;
  }
};

const ConvertData = (data, parentKey = "") => {
  for (let index = 0; index < data.length; index++) {
    const item = data[index];
    item.key = item.parentId != null ? item.parentId + "-" + item.id : item.id;
    item.key = parentKey != "" ? parentKey + "-" + item.id : item.key;
    item.label = item.itmsGrpName;
    if (item.child.length) {
      item.children = item.child;
      ConvertData(item.child, item.key);
    }
  }
};

const getItemData = async (key) => {
  try {
    const res = await API.get(`Item/search/${key}`);
    for (let index = 0; index < res.data.length; index++) {
      const element = res.data[index];
      element.name = element.itemName;
    }
    DataItem.value = res.data;
  } catch (error) {}
};
const debouncedFetchProduct = debounce(getItemData, 300);

const SearchItemData = (event) => {
  debouncedFetchProduct(event.query);
};
const saveData = () => {
  data.value = [];
  const dataArr = Object.keys(dataNode.value)
  for (let index = 0; index < dataArr.length; index++) {
    const element = dataArr[index];
    getDataGroupItem(dataGroupItem.value, element);
  }
  dialogGroupItem.value = false;
  emit("handle", true);
};

const getDataGroupItem = (d, key) => {
  d.forEach((item) => {
    if (key.toString() == item.key.toString()) {
      item.name = item.itmsGrpName;
      item.type = "G";
      item.itemGroupId = item.id;
      data.value.push(item);
    } else {
      if (item.children) {
        getDataGroupItem(item.children, key);
      }
    }
  });
};


const FunChangeItem = (e) => {
  emit("handle", true);
  try {
    if (data.value[data.value.length - 1].itemCode) {
      const count_item = data.value.filter((val) => {
        return val.itemCode == data.value[data.value.length - 1].itemCode;
      });
      if (count_item.length > 1) {
        data.value.splice(data.value.length - 1, 1);
      }
      const count_Group = data.value.filter((val) => {
        return val.type == "G" || val.type == "IG";
      });
      if (count_Group.length > 0) {
        data.value.splice(0, data.value.length - 1);
      }
    }
  } catch {}
};




const updateData = async (data) => {
  try {
    // const res = await API.get("ItemGroup");
    // if (res.data.itemGroup) dataGroupItem.value = res.data.itemGroup;
    ConvertData(dataGroupItem.value);
  } catch (error) {
  } finally {
    dataNode.value = {};
    data.forEach((item) => {
      if (item.itemGroupId) {
        let key = FindByID(item.itemGroupId, dataGroupItem.value).key;
        key = key.toString().split("-");
        if (key.length == 3) {
          const dataNew = {};
          dataNew[key[0]] = { checked: false, partialChecked: true };
          dataNew[key[0] + "-" + key[1]] = {
            checked: false,
            partialChecked: true,
          };
          dataNew[key[0] + "-" + key[1] + "-" + key[2]] = {
            checked: true,
            partialChecked: false,
          };
          Object.assign(dataNode.value, dataNew);
        }
        if (key.length == 2) {
          const dataNew = {};
          dataNew[key[0]] = { checked: false, partialChecked: true };
          dataNew[key[0] + "-" + key[1]] = {
            checked: true,
            partialChecked: false,
          };
          SetValueTrueV2(key[1], dataGroupItem.value);
          Object.assign(dataNode.value, dataNew);
        }

        if (key.length == 1) {
          const dataNew = {};

          dataNew[key[0]] = { checked: true, partialChecked: false };
          Object.assign(dataNode.value, dataNew);
          SetValueTrue(key[0], dataGroupItem.value);
        }
      }
    });
  }
};

const FindByID = (id, data) => {
  for (let index = 0; index < data.length; index++) {
    const item = data[index];
    if (item.id == id) {
      return item;
    }
    if (item.children) {
      const found = FindByID(id, item.children);
      if (found) return found;
    }
  }
  return null;
};

const SetValueTrueV2 = (id, data) => {
  const Arr = FindChild(id, data);
  Arr.forEach((item) => {
    let key = FindByID(item.id, data).key;
    key = key.toString().split("-");
    if (key.length == 3) {
      const dataNew = {};
      dataNew[key[0] + "-" + key[1] + "-" + key[2]] = {
        checked: true,
        partialChecked: false,
      };
      Object.assign(dataNode.value, dataNew);
    }
  });
};

const SetValueTrue = (id, data) => {
  const Arr = FindChild(id, data);
  Arr.forEach((item) => {
    let key = FindByID(item.id, data).key;
    key = key.toString().split("-");
    if (key.length == 2) {
      const dataNew = {};
      dataNew[key[0] + "-" + key[1]] = {
        checked: true,
        partialChecked: false,
      };
      Object.assign(dataNode.value, dataNew);
      SetValueTrueV2(key[1], data);
    }
  });
};

const FindChild = (id, data) => {
  const tem = [];
  for (let index = 0; index < data.length; index++) {
    const item = data[index];
    if (parseInt(item.parentId) === parseInt(id)) {
      tem.push(item);
    }
    if (item.children && item.children.length > 0) {
      tem.push(...FindChild(id, item.children));
    }
  }
  return tem;
};

watchEffect(() => {
  emit("change", data.value);
});

if (props.data_req.length > 0) {
  data.value = props.data_req;
  data.value.forEach((item) => {
    item.name = item.itmsGrpName ? item.itmsGrpName : item.itemName;
  });
  updateData(data.value);
}


</script>
